export default "__VITE_ASSET__76dd2f9c__"